import { isEmpty } from '@utils/checkers'
import { useUser } from '../modules/App/user'

export type LangPerSpace = { spaceId?: number; lang?: string }

export type LocalStorageSpacesSettings = {
  settings: LangPerSpace[]
  expires: number
}

export function getLanguageSettings(): LangPerSpace[] {
  const userStore = useUser()
  const settingItem: LocalStorageSpacesSettings = JSON.parse(
    localStorage.getItem(`languageSettings-${userStore?.user?.id}`),
  )
  const today = new Date()

  // expire the language settings after 3 days
  if (settingItem && today.getTime() > settingItem.expires) {
    localStorage.removeItem(`languageSettings-${userStore?.user?.id}`)
    return []
  }

  return (
    settingItem?.settings.reduce<LangPerSpace[]>((acc, item) => {
      if (item) {
        acc.push(item)
      }

      return acc
    }, []) || []
  )
}

export function setLanguageSettings(languageSettings: LangPerSpace[]): void {
  const userStore = useUser()
  const today = new Date()
  const days = 3
  const expireDate = new Date(
    today.setTime(today.getTime() + days * 86400000),
  ).getTime()

  localStorage.setItem(
    `languageSettings-${userStore?.user?.id}`,
    JSON.stringify({
      settings: languageSettings,
      expires: expireDate,
    }),
  )
}

export function findLanguageIndexBySpaceId(spaceId: number): number {
  const userStore = useUser()
  const settingItem: LocalStorageSpacesSettings = JSON.parse(
    localStorage.getItem(`languageSettings-${userStore?.user?.id}`),
  )

  if (isEmpty(settingItem)) {
    return -1
  }
  return settingItem.settings.findIndex(
    (entry) => Number(entry?.spaceId) === Number(spaceId),
  )
}
